import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocalizedFormatters } from 'i18n/useLocalizedFormatters'


export default function PayoutsItem(props) {
    const { t } = useTranslation('giving')
    const { formatCurrency, formatDate } = useLocalizedFormatters()

    const { destInfo, getPayoutsSuccess } = useSelector(state => state.giving)
 

    return (
        <tr>
            <td>{formatDate(props.data.created * 1000)}</td>
            <td>{formatCurrency(props.data.amount)}</td>
            {
                getPayoutsSuccess && destInfo[props.data.destination] ?
                (
                    <td> {destInfo[props.data.destination].name} - {destInfo[props.data.destination].last4}   </td>

                )
                :
                (
                    <td> ... </td>
                )
            } 
            <td>{formatDate(props.data.arrival_date * 1000)}</td>
            <td>{t(`payouts.status.${props.data.status}`, { defaultValue: props.data.status })}</td>
        </tr>
    )
}
